import styled from "@emotion/styled";

export const IconWrap = styled.div`
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 15px;
  margin-left: auto;
  width: 22px;
  height: 22px;
  margin-bottom: 10px;
  @media (min-width: 769px) {
    margin-top: 12px;
  }
  .icon {
    width: 100%;
    height: 100%;
  }
`;
